import React, { useState, useEffect } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import _ from "lodash";
import Modal from "react-bootstrap/Modal";
import Loading from "./common/loading";
import Input from "./common/input";
import Pagination from "./common/pagination";
import http from "../services/http";
import { paginate } from "../utils/paginate";

const LookupsCard = ({ name }) => {
  const [lookups, setLookups] = useState([]);
  const [loading, setLoading] = useState(true);
  const pageSize = 12;
  const navigation = '';
  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("");
  const [show, setShow] = useState(false);
  const [create, setCreate] = useState(false);
  const [type, setType] = useState("");
  const [selected, setSelected] = useState({ code: "", description: "" });

  useEffect(() => {
    async function getLookups() {
      try {
        const { data } = await http.get(`/lookups/${name}`);
        setLookups(data);
      }
      catch {
        //ignore error
      }

      setLoading(false);
    }
    
    getLookups();
  }, [name]);

  function handleNewLookup(type) {
    setCreate(true);
    setType(type);
    setSelected({ code: "", description: "" });
    setShow(true);
  }

  function handleEditLookup(lookup, type) {
    setCreate(false);
    setType(type);
    setSelected(_.pick(lookup, ["code", "description"]));
    setShow(true);
  }

  function handleModalChange({ currentTarget: input }) {
    setSelected({ ...selected, [input.name]: input.value });
  }

  function getCodeLabel(n) {
    n = n.charAt(0).toUpperCase() + n.slice(1);
    return n.substring(0, n.length) + " Code";
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (create) {
      try {
        const { data } = await http.post(`/lookups/${name}`, selected);
        // Update Table
        setLookups(_.sortBy([...lookups, data], "description"));
        setShow(false);
        toast.success("Lookup Created");
      } catch (ex) {
        if (ex.response && ex.response.status < 500) {
          toast.error(ex.response.data);
        }
      }
    } else {
      // Update Table
      const oldLookups = lookups;
      const index = lookups.findIndex((l) => l.code === selected.code);
      const newLookups = [...lookups];
      try {
        const { data } = await http.patch(`/lookups/${name}`, selected);
        newLookups[index] = data;
        setLookups(newLookups);
        setShow(false);
        toast.success("Lookup Updated");
      } catch (ex) {
        setLookups(oldLookups);
      }
    }
  }

  async function handleDelete(lookup) {
    try {
      await http.delete(`/lookups/${name}/${lookup.code}`);
      setLookups(lookups.filter((l) => l.code !== lookup.code));
      toast.success("Code Deleted");
    } catch (ex) {
      if (ex.response) {
        toast.error(ex.response.data);
      }
    }
  }

  const handleQueryChange = ({ currentTarget: input }) => {
    setCurrentPage(1);
    setQuery(input.value);
  };

  let filtered = lookups;
  if (query)
    filtered = lookups.filter(
      (l) =>
        l.code.includes(query.toUpperCase()) ||
        l.description.toUpperCase().includes(query.toUpperCase())
    );
  let data = paginate(filtered, currentPage, pageSize);

  let heading = "";
  if (create) heading = "Create " + _.capitalize(name);
  else heading = "Edit " + _.capitalize(name);

  return (
    <div className="mx-3">
      {loading ? (
        <Loading />
      ) : (
        <React.Fragment>
          <div className="row">
            <div className="col">
              <h3>{_.capitalize(name)}</h3>
            </div>
          </div>
          <div className="row">
            <div className="col-auto">
              <button
                className="btn btn-primary"
                onClick={() => handleNewLookup()}
              >
                New
              </button>
            </div>
            <div className="col">
              <Input
                name="query"
                placeholder={`Search ${name}...`}
                value={query}
                onChange={handleQueryChange}
              />
            </div>
          </div>
          <div className="row">
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Parameters</th>
                  <th>Active Parameters</th>
                  <th>Last Updated</th>
                  <th>Updated By</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {data.map((lookup) => (
                  <tr key={lookup.code}>
                    <td>
                      <button
                        className="btn btn-link"
                        onClick={() => handleEditLookup(lookup)}
                      >
                        {lookup.code}
                      </button>
                    </td>
                    <td>{lookup.description}</td>
                    <td>{lookup.parameters}</td>
                    <td>{lookup.active_parameters}</td>
                    <td>{moment(lookup.updatedAt).fromNow()}</td>
                    <td>{lookup.updatedBy}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(lookup)}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="row">
            <Pagination
              itemsCount={filtered.length}
              pageSize={pageSize}
              currentPage={currentPage}
              onPageChange={(p) => setCurrentPage(p)}
              navigation={navigation}
            />
          </div>
          <Modal show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton className="bg-success text-white">
              <Modal.Title>{heading}</Modal.Title>
            </Modal.Header>
            <form>
              <Modal.Body>
                <Input
                  name="code"
                  label={getCodeLabel(name)}
                  placeholder="Code"
                  value={selected.code}
                  onChange={handleModalChange}
                  disabled={!create}
                />
                <Input
                  name="description"
                  label="Name"
                  placeholder="Name"
                  value={selected.description}
                  onChange={handleModalChange}
                />
              </Modal.Body>
              <Modal.Footer>
                <button className="btn btn-primary" onClick={handleSubmit}>
                  {create ? "Create" : "Update"}
                </button>
              </Modal.Footer>
            </form>
          </Modal>
        </React.Fragment>
      )}
    </div>
  );
};

export default LookupsCard;
